import type { SignInInput } from '@/schemas/sign-in-schema';
import type { SignUpFormData } from '@/schemas/signup-schema';
import { useState } from 'react';
import type { FieldValues, UseFormReturn } from 'react-hook-form';
import { useHotkeys } from 'react-hotkeys-hook';

const seedData = {
  signin: {
    email: 'netao.bombeef@mailinator.com',
    password: 'Vibe@1234',
  },
  signup: {
    displayName: 'Netao Bombeef',
    email: 'netao.bombeef@mailinator.com',
    password: 'Vibe@1234',
    phone: '11987654321',
    marketingOptIn: false,
    termsAccepted: true,
  },
};

export const useCBJR = (
  form: UseFormReturn<SignUpFormData | SignInInput>,
  onSubmit: (data: SignUpFormData | SignInInput) => void
) => {
  const [showCBJR, setShowCBJR] = useState(false);

  useHotkeys('c+b+j+r', () => {
    if ('displayName' in form.getValues()) {
      form.setValue('displayName', seedData.signup.displayName);
      form.setValue('phone', seedData.signup.phone);
      form.setValue('marketingOptIn', seedData.signup.marketingOptIn);
      form.setValue('termsAccepted', seedData.signup.termsAccepted);
    }
    form.setValue('email', seedData.signin.email);
    form.setValue('password', seedData.signin.password);

    form.trigger().then(() => {
      if (form.formState.isValid) {
        setTimeout(() => {
          form.handleSubmit(onSubmit)();
        }, 2000);
      }
    });
    setShowCBJR(true);
  });

  return { showCBJR, setShowCBJR };
};

export function CBJRImage({
  showCBJR,
  setShowCBJR,
}: { showCBJR: boolean; setShowCBJR: (show: boolean) => void }) {
  return (
    <div className={`absolute right-0 top-20 ${showCBJR ? 'block' : 'hidden'}`}>
      <img
        src="https://static.tumblr.com/4c4080dcd5ecc0dda69718e7a716cf37/1uskght/puzo1q98z/tumblr_static_filename.gif"
        alt="Charlie Brown Junior"
      />
    </div>
  );
}
